import {
  useCrearRol,
  useEditarRol,
  useEliminarRol,
  useListarRoles,
} from "../../../../Hooks/Admin";
import { CustomForm } from "../../../../Components/Admin/CustomForm";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import {
  camposFormulario,
  columns,
  formatData,
  camposFilter,
} from "./camposFormulario";

export const RolesForm = () => {
  return (
    <>
      <CustomForm
        camposFormulario={camposFormulario}
        querySubmit={useCrearRol}
      />
    </>
  );
};

export const RolesEditar = () => {
  return (
    <CustomTable
      camposFilter={camposFilter}
      camposFormularioModal={camposFormulario}
      queryListar={useListarRoles}
      queryEditar={useEditarRol}
      formatData={formatData}
      columns={columns}
      editable={true}
      camposAgregar={camposFormulario}
      queryCrear={useCrearRol}
      canDelete={true}
      queryBorrarFila={useEliminarRol}
    />
  );
};
